/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const LightningOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m9 22.5 1.5-7.5-6-2.25L15 1.5 13.5 9l6 2.25L9 22.5z"
})));
// Fill
const LightningFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.23 11.08a.746.746 0 0 0-.17-.33.691.691 0 0 0-.3-.2l-5.4-2.03 1.37-6.87c.03-.16.01-.32-.06-.47s-.18-.27-.32-.35a.769.769 0 0 0-.47-.07c-.16.02-.31.1-.42.22L3.96 12.23c-.09.09-.15.2-.18.32-.04.12-.04.25-.01.37s.09.23.17.32c.08.1.18.17.3.21l5.4 2.03-1.37 6.87c-.03.16-.01.32.06.47s.18.27.32.35c.11.05.23.08.35.08.1 0 .2-.02.3-.06.09-.04.17-.1.24-.17l10.5-11.25c.09-.09.15-.2.18-.32.04-.12.04-.25.01-.37z"
})));
// DuoTone
const LightningDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m9 22.5 1.5-7.5-6-2.25L15 1.5 13.5 9l6 2.25L9 22.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m9 22.5 1.5-7.5-6-2.25L15 1.5 13.5 9l6 2.25L9 22.5z"
})));
/**
  Icon LightningIcon in system group
*/
export const LightningIcon = createIcon('LightningIcon', 'lightning', 'system', LightningOutline, LightningFill, LightningDuotone, "0 0 24 24");